function Home() {
  return (
    <>
      <div>Home</div>
      <p>Getting Started with Vesselize and React.</p>
      <p>
        <a
          href="https://github.com/vesselize/vesselize-react-starter"
          target="_blank"
          rel="noreferrer"
        >
          Github Source
        </a>
      </p>
    </>
  );
}

export default Home;
